import React from "react";
import { colors2, UI_CAPTION_SEMIBOLD } from "oolib";
import styled from "styled-components";

export const BetaStyledWrapper = styled.div`
  padding: 0 0.4rem;
  border-radius: 0.4rem;
  background: linear-gradient(
    118.55deg,
    #9dffea -18.66%,
    #bdd4ff 52.78%,
    #ffc9f0 122.8%
  );
`;

export const PopOutBadge = ({text = 'Beta'}) => {
  return (
    <BetaStyledWrapper style={{color: colors2.grey90}}>
      <UI_CAPTION_SEMIBOLD>{text}</UI_CAPTION_SEMIBOLD>
    </BetaStyledWrapper>
  );
};
